import dayjs, { type ConfigType } from "dayjs";

export function formatHeaderDate(date: Date) {
  return dayjs(date).format("D MMM");
}

export function getDateString(date: NonNullable<ConfigType>) {
  return dayjs(date).format("YYYY-MM-DD");
}

export const numericDateFormatOptions: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

export const longDateFormatOptions: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "long",
  year: "numeric",
};
